import { useState, useEffect } from "react";
import { Avatar, Box, Stack, IconButton, Tooltip } from "@mui/material";
import { ToastContainer } from "react-toastify";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { green } from "@mui/material/colors";
import ReactMarkdown from "react-markdown";
import ChatInput from "./ChatInput";
import TopBar from "./TopBar";
import remarkGfm from "remark-gfm";

const ChatMessagesPage = ({
  displayName,
  messages,
  messageType,
  userName,
  botName,
  onNewChat,
  onViewHistory,
  question,
  setQuestion,
  onRequest,
  getCaptionsAnswer,
  onEnterPress,
  chatWrapperRef,
  botIconImg
}) => {
  const tc_icon = require("../../../images/"+botIconImg);
  const [tooltipText, setTooltipText] = useState("Copy");

  useEffect(() => {
    if (chatWrapperRef?.current) {
      chatWrapperRef.current.scrollTop = chatWrapperRef.current.scrollHeight;
    }
  }, [messages]);

  const nameFormat = () => {
    var firstLetter = sessionStorage.getItem("givenName").split(" ")[0][0];
    return firstLetter;
  };

  const formatMarkdownComponents = () => {
    return {
      code: ({ node, inline, className, children, ...props }) => {
        const codeText = String(children).trim();
        const match = /language-(\w+)/.exec(className || "");
        const language = match ? match[1] : "";

        if (inline) {
          return (
            <code
              style={{
                backgroundColor: "#f0f0f0",
                padding: "2px",
                scrollbarWidth: "none",
                 borderRadius: "4px",
              fontFamily: "monospace",
              }}
              {...props}
            >
              {children}
            </code>
          );
        } else {
          return (
          <Box
            sx={{
              position: "relative",
              backgroundColor: "#f0f0f0",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "10px",
              overflowX: "auto",
              fontFamily: "monospace",
            }}
          >
            {/* Language label */}
        {language && (
          <Box
            sx={{
              position: "absolute",
              top: "0px",
              left: "10px",
              fontSize: "12px",
              fontWeight: "bold",
              color: "#555",
              backgroundColor: "#ddd",
              padding: "2px 6px",
              borderRadius: "4px",
              textTransform: "uppercase",
            }}
          >
            {language}
          </Box>
        )}
            <Tooltip title={tooltipText} arrow>
              <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  color: "black",
                  "&:hover": {
                    color: "rgba(15, 87, 220, 0.78)",
                    backgroundColor: "#fff",
                    boxShadow: "2px 2px 6px rgba(96, 126, 183, 0.78)",
                  },
                }}
                onClick={() => copyToClipboard(codeText)}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <pre style={{
                    paddingTop: language ? "30px" : "10px", // extra top padding if label exists
                    margin: 0,
                    textWrap: "auto"
                  }}
            >
              <code className={className}{...props}>{codeText}</code>
            </pre>
          </Box>
        );
      
        }
      },
      img: ({ node, inline, className, children, ...props  }) => (
      <img
        {...props}
        style={{
          maxWidth: "100%",  
          height: "auto",
          width: "60%",    
          display: "block",
          margin: "20px",
          boxShadow: "0 5px 10px #b8c0c2ff",
          objectFit: "cover", 
        }}
        alt={props.alt || "image"}
      />
      ),
      h1: ({ node, inline, className, children, ...props }) => {
        return <h6 {...props}>{children}</h6>;
      },
      h2: ({ node, inline, className, children, ...props }) => {
        return <h6 {...props}>{children}</h6>;
      },
      h3: ({ node, inline, className, children, ...props }) => {
        return <h6 {...props}>{children}</h6>;
      },
      h4: ({ node, inline, className, children, ...props }) => {
        return <h6 {...props}>{children}</h6>;
      },
      h5: ({ node, inline, className, children, ...props }) => {
        return <h6 {...props}>{children}</h6>;
      },
    };
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setTooltipText("Copied!"); // Change tooltip text
      setTimeout(() => setTooltipText("Copy"), 2000); // Reset after 2 seconds
    });
  };
  return (
    <div className="analytics">
      <TopBar
        displayName={displayName}
        showNewChat={onRequest ? false : true}
        showHistoryButton={onViewHistory ? onRequest ? false : true : false}
        onNewChat={onNewChat}
        onViewHistory={onViewHistory}
      />

      <div className="card cardAdditionalStyling">
        <ToastContainer />
        <div
          ref={chatWrapperRef}
          className="card subcard box-container"
          id="mainScrollableDiv"
        >
          <Box className="messageBox">
            <Box className="boxStyling">
              {messages.map((item, index) => (
                <Box key={index}>
                  <Stack spacing={2} direction={"row"}>
                    {item.role === messageType.answer ? (
                      <Avatar
                        sx={{ width: 35, height: 35 }}
                        style={{ marginTop: "15px" }}
                      >
                        <p className="pBot">
                          <img alt="" src={tc_icon} width="36" />
                        </p>
                      </Avatar>
                    ) : (
                      <Avatar
                        sx={{ bgcolor: green[800], width: 35, height: 35 }}
                        style={{ marginTop: "15px" }}
                      >
                        {userName !== "" ? (
                          <p className="pBot">{nameFormat()}</p>
                        ) : null}
                      </Avatar>
                    )}
                    <Box sx={{ padding: 1, borderRadius: 3 }}>
                      {item.role === messageType.answer ? (
                        <div className="text-section">
                          <h6 style={{ marginTop: "10px" }}>
                            {botName}
                          </h6>
                          <Box
                            sx={{
                              position: "relative",
                              borderRadius: "8px",
                              padding: "10px",
                              backgroundColor: "#fff",
                              minHeight: "60px",
                              border: "1px solid rgba(215, 218, 225, 0.69)",
                              overflowWrap: "break-word",   
                              wordBreak: "break-word",      
                              boxShadow:
                                "2px 2px 6px rgba(215, 218, 225, 0.69)",
                              "&:hover": {
                                boxShadow:
                                  "2px 2px 6px rgba(96, 126, 183, 0.78)",
                                //transform: "scale(.05)", // Slight scaling effect on hover
                              },
                            }}
                          >
                            
                            <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                              components={formatMarkdownComponents()}
                            >
                              {item.content}
                            </ReactMarkdown>
                          </Box>
                        </div>
                      ) : (
                        <div className="text-section">
                          <h6 style={{ marginTop: "10px" }}>{userName}</h6>
                          <Box
                            sx={{
                              wordBreak: "break-word",
                              whiteSpace: "pre-wrap",
                              borderRadius: "8px",
                              padding: "8px",
                              paddingTop:"12px",
                              border: "1px solid rgba(161, 179, 220, 0.9)",
                              boxShadow: "1px 1px 3px rgba(214, 219, 231, 0.9)",
                            }}
                          >
                            <ReactMarkdown>{item.content}</ReactMarkdown>
                          </Box>
                        </div>
                      )}
                    </Box>
                  </Stack>
                </Box>
              ))}
            </Box>
          </Box>
        </div>
        <ChatInput
          question={question}
          setQuestion={setQuestion}
          onRequest={onRequest}
          getCaptionsAnswer={getCaptionsAnswer}
          onEnterPress={onEnterPress}
          //onSendFirstQuestion={onSendFirstQuestion}
        />
      </div>
    </div>
  );
};

export default ChatMessagesPage;
